import * as React from 'react';
import ReactTable, { RowInfo } from 'react-table';
import { Creatable as Select } from 'react-select';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';

import Pagination from '../../common/pagination';
import NotifyHOC, { IToastNotification } from '../../../HOC/Notifications';
import NoOptionsMessage from '../../common/reactSelect/NoOptionsMessage';
import IndicatorsContainer from '../../common/reactSelect/IndicatorsContainer';
import Loader from '../../common/Loader/Loader';
import { IApplicationState } from '../../../reducers';
import {
    getAllOptionPacks,
    duplicateOptionPack,
    deleteOptionPack
} from '../../../services/optionpack.service';
import { OptionWithoutCreateTag } from '../../common/reactSelect/Option';
import { NEW_OPTION_PACK, OPTION_PACKS } from '../../../constants/routes';
import { push } from 'connected-react-router';
import DuplicateOptionPackModal from '../../common/DuplicateOptionPackModal';
import { getConfirmationBox } from '../../common/swal/Sweetalert';
import { alertMessage } from '../../../constants/alertMessage';

const sharedOptions = [
    { label: 'All Items', value: 'allResults' },
    { label: 'Default', value: 'onlyShared' },
    { label: 'Custom', value: 'onlyUser' }
];

export interface IOptionPackListProps {
    optionList: any[];
    toastNotification: IToastNotification;

    goToRoute: (url: string) => void;
    getAllOptionPacks: () => Promise<any>;
    deleteOptionPack: (id: number) => Promise<any>;
    duplicateOptionPack: (id: number, data: any) => Promise<any>;
    selectedOptionPack: any | null;
    setOptionPack: (selectedOptionPack: any) => void;
    as: 'modal' | 'route';
}

export interface IOptionPackListState {
    isLoading: boolean;
    selectedTags: any[];
    showDuplicateModal: boolean;
    currentOptionPack: any;
    selectedSharedOption: {
        label: string;
        value: string;
    };
}

class OptionPackList extends React.Component<
    IOptionPackListProps,
    IOptionPackListState
> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedTags: [],
            selectedSharedOption: { label: 'All Items', value: 'allResults' },
            showDuplicateModal: false,
            currentOptionPack: null
        };
    }
    componentDidMount() {
        this.setState(
            {
                isLoading: true
            },
            () => {
                this.props.getAllOptionPacks().then(
                    () => {
                        this.setState({ isLoading: false });
                    },
                    () => {
                        this.setState({ isLoading: false });
                    }
                );
            }
        );
    }
    buildColumns = [
        {
            Header: 'Group label',
            accessor: 'label',
            resizable: false,
            className: '',
            Cell: (props) => <span>{props.value}</span>
        },
        {
            Header: 'Options',
            accessor: 'options', // Note: Example of direct accessing data from accessor
            resizable: false,
            minWidth: 400, // Note: Example of midWidth
            className: 'no-truncate',
            Cell: (props) => {
                const list = (props.value || []).map((option, index) => {
                    return (
                        <li key={index} className="option-pack__items">
                            {option.mediaURL ? (
                                <span className="option-pack__img-hold">
                                    <img src={option.mediaURL} />
                                </span>
                            ) : null}
                            {option.label}
                        </li>
                    );
                });
                return <ul className="option-pack">{list}</ul>;
            }
        },
        {
            Header: 'Languages',
            accessor: 'languages',
            resizable: false, // Note: Example of resizable
            className: 'align-right', // Note: Class name example

            Cell: (props) => {
                const languages = (props.original.languages || []).map(
                    (l) => l.label || l.title
                );
                return (
                    <React.Fragment>
                        <a
                            className="text-link"
                            data-event="click"
                            data-tip="custom show"
                            data-for={`language-link-${props.original.id}`}
                        >
                            {props.value.length > 1
                                ? `${props.value.length} languages`
                                : `${props.value.length} language`}
                        </a>
                        <ReactTooltip
                            id={`language-link-${props.original.id}`}
                            aria-haspopup="true"
                            effect="solid"
                            place="bottom"
                        >
                            <span>{languages.join(', ')}</span>
                        </ReactTooltip>
                    </React.Fragment>
                );
            }
        },

        {
            Header: 'Shared',
            accessor: 'userUpload',
            className: 'align-center',
            headerClassName: 'align-center no-sort',
            Cell: (props) => (
                <span>{props.value == true ? 'User' : 'Admin'}</span>
            )
        },
        {
            Header: 'Actions',
            accessor: '',
            className: 'align-center',
            headerClassName: 'align-center no-sort',
            Cell: (props) => (
                <ul className="table__actions">
                    {/* <li onClick={() => this.duplicateOptionPack(props.original)} className="action__items"><i className="nx nx-duplicate" /></li> */}
                    {this.props.as === 'route' ? (
                        <>
                            <li
                                onClick={() =>
                                    this.editOptionPack(props.original)
                                }
                                className="action__items"
                                data-tip="custom show"
                                data-for={`edit-${props.original.id}`}
                            >
                                <i className="nx nx-edit" />
                            </li>
                            <ReactTooltip
                                id={`edit-${props.original.id}`}
                                aria-haspopup="true"
                                effect="solid"
                                place="bottom"
                            >
                                <span>Edit option pack</span>
                            </ReactTooltip>
                            <li
                                onClick={() =>
                                    this.deleteOptionPack(props.original)
                                }
                                className="action__items"
                                data-tip="custom show"
                                data-for={`delete-${props.original.id}`}
                            >
                                <i className="nx nx-delete" />
                            </li>
                            <ReactTooltip
                                id={`delete-${props.original.id}`}
                                aria-haspopup="true"
                                effect="solid"
                                place="bottom"
                            >
                                <span>Delete option pack</span>
                            </ReactTooltip>
                        </>
                    ) : null}
                </ul>
            )
        }
    ];

    getTrProps = (state, rowInfo: RowInfo) => ({
        onClick: (e, t) => {
            this.props.setOptionPack(rowInfo.original);
        },
        style: {},
        className: classnames({
            'rt-tr-selected':
                !!this.props.selectedOptionPack &&
                rowInfo &&
                rowInfo.original.id === this.props.selectedOptionPack.id,
            'cursor-pointer': this.props.as === 'modal'
        })
    });

    handleRadioSelection = (selectedSharedOption: any) => {
        this.setState({ selectedSharedOption });
    };

    handleSelect = (selectedTags: any) => {
        this.setState({
            selectedTags
        });
    };

    filteredOptionPack = () => {
        const { selectedSharedOption } = this.state;
        let optionlist = this.props.optionList;
        if (selectedSharedOption.value !== 'allResults') {
            optionlist = optionlist.filter((m, i) => {
                if (
                    selectedSharedOption.value === 'onlyShared' &&
                    m.userUploaded === false
                ) {
                    return true;
                } else if (
                    selectedSharedOption.value === 'onlyUser' &&
                    m.userUploaded === true
                ) {
                    return true;
                }
                return false;
            });
        }
        if (this.state.selectedTags && this.state.selectedTags.length) {
            const mappedSelectedTags = this.state.selectedTags.map((m) =>
                m.value.toLowerCase()
            );
            optionlist = optionlist.filter((o, i) => {
                let allow = false;
                mappedSelectedTags.forEach((selectedTags) => {
                    if (
                        (o.label || '').toLowerCase().indexOf(selectedTags) > -1
                    ) {
                        allow = true;
                    } else if (
                        selectedTags.indexOf((o.label || '').toLowerCase()) > -1
                    ) {
                        allow = true;
                    }
                });
                return allow;
            });
        }
        return optionlist;
    };

    saveDuplicateOptionPack = async (values: any, { setSubmitting }) => {
        const { currentOptionPack } = this.state;
        try {
            const optionpack: any = await Promise.resolve();
            setSubmitting(false);
            this.setState(
                {
                    showDuplicateModal: false,
                    currentOptionPack: null
                },
                () => {
                    this.props.goToRoute(`${OPTION_PACKS}/${optionpack.id}`);
                }
            );
        } catch (e) {
            setSubmitting(false);
        }
    };

    openDuplicateOptionPack = (option) => {
        this.setState({
            showDuplicateModal: true,
            currentOptionPack: option
        });
    };

    closeDuplicateOptionPack = () => {
        this.setState({
            showDuplicateModal: false,
            currentOptionPack: null
        });
    };

    editOptionPack = (option) => {
        this.props.goToRoute(`${OPTION_PACKS}/${option.id}`);
    };

    deleteOptionPack = async (option) => {
        try {
            const result = await getConfirmationBox({
                message: alertMessage.CONFIRM_DELETE_ITEM,
                showCloseButton: true,
                confirmButtonColor: '',
                title: alertMessage.DELETE_ITEM
            });
            if (result && result.value) {
                await this.props.deleteOptionPack(option.id);
                alertMessage.DELETE_OPTIONPACK;
            }
        } catch (e) {
            this.props.toastNotification.error('Issue in deleting option pack');
        }
    };

    goToOptionPackAdd = () => {
        this.props.goToRoute(NEW_OPTION_PACK);
    };

    render() {
        const optionList = this.filteredOptionPack();
        const { isLoading } = this.state;
        return (
            <div className="media-library-content">
                {this.state.showDuplicateModal ? (
                    <DuplicateOptionPackModal
                        duplicatedOptionPack={this.state.currentOptionPack}
                        handleSubmit={this.saveDuplicateOptionPack}
                        onClose={this.closeDuplicateOptionPack}
                    />
                ) : null}
                <div className="media-library--filters">
                    <div className="filters--search-tags">
                        <Select
                            className="react-select filter"
                            classNamePrefix="react-select"
                            value={this.state.selectedTags}
                            onChange={this.handleSelect}
                            isMulti
                            isSearchable
                            placeholder="Search by option group"
                            components={{
                                IndicatorsContainer,
                                NoOptionsMessage,
                                Option: OptionWithoutCreateTag
                            }}
                            // menuIsOpen={true}
                        />
                    </div>
                    <div className="filters--shared">
                        <Select
                            className="react-select filter"
                            classNamePrefix="react-select"
                            placeholder="All items"
                            value={this.state.selectedSharedOption}
                            options={sharedOptions}
                            onChange={this.handleRadioSelection}
                            components={{
                                IndicatorsContainer
                            }}
                        />
                    </div>
                    <div className="filters--action-buttons">
                        <button
                            className="btn btn--md btn--green"
                            onClick={this.goToOptionPackAdd}
                        >
                            <i className="nx nx-add"></i>Add option packs
                        </button>
                    </div>
                </div>
                <div className="media-library--media-list-container">
                    {!isLoading ? (
                        <ReactTable
                            data={optionList}
                            columns={this.buildColumns}
                            // filterable
                            defaultSorted={[
                                // Note: Example of asc / desc value by table specific header
                                {
                                    id: 'userName',
                                    desc: false // Desc: false ---> ascending order, Desc: true ---> descending
                                }
                            ]}
                            getTrProps={this.getTrProps}
                            defaultPageSize={5}
                            pageSizeOptions={[5, 10, 15, 20]}
                            PaginationComponent={Pagination}
                            loading={!!isLoading}
                            NoDataComponent={NoDataComponent}
                        />
                    ) : (
                        <Loader />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ optionpackReducer }: IApplicationState) => ({
    optionList: optionpackReducer.optionpacks
});

const mapDispatchToProps = (dispatch) => ({
    goToRoute: (url: string) => dispatch(push(url)),
    getAllOptionPacks: () => dispatch(getAllOptionPacks()),
    deleteOptionPack: (id) => dispatch(deleteOptionPack(id)),
    duplicateOptionPack: (id: number, data: any) =>
        dispatch(duplicateOptionPack(id, data))
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(OptionPackList)
);

const NoDataComponent: React.SFC = ({ children }) => (
    <div className="rt-noData">{children}</div>
);
